export type ExceededRecordLimitData = {
  importMethod: ImportMethod;
  limitType: ExceededLimitType;
  actualCount: number;
  maxCountAllowed: number;
};

/**
 * How the transaction was added to the Syla Account.
 */
export enum ImportMethod {
  /**
   * An uploaded file.
   */
  File = "File",

  /**
   * An API or OAuth sync
   */
  Sync = "Sync",

  /**
   * Added manually through the UI,
   */
  Manual = "Manual",
}

export enum ExceededLimitType {
  /**
   * Exceeded the maximum number of source records allowed during parsing.
   *
   * e.g. too many rows in a CSV file uploaded, or too many
   * items in a JSON dataset synced from an API.
   */
  RecordLimit = "RecordLimit",

  /**
   * Importing the transactions would have exceeded the total number of
   * transactions allowed in the users Syla account, across all data sources.
   */
  AccountTransactionLimit = "AccountTransactionLimit",

  /**
   * Importing the transactions would have exceeded the maximum number of
   * transactions allowed in a single import for this specific data source.
   *
   * e.g. we may limit the max number of transactions allowed to sync on
   * certain blockchain data sources to ensure the sync will finish.
   */
  DataSourceTransactionLimit = "DataSourceTransactionLimit",
}
